import { track } from 'ripple';

export component LandingPage(props) {
	let showSignIn = track(false);
	let showRegister = track(false);
	let onAuth = props.onAuth;
	let onDashboard = props.onDashboard;

	<div class="landing-container">
		// Navigation
		<nav class="navbar">
			<div class="nav-brand">{"CrossSwap"}</div>
			<div class="nav-links">
				<button class="btn btn-link" onClick={() => @onAuth()}>{"Sign In"}</button>
				<button class="btn btn-primary" onClick={() => @onAuth()}>{"Register"}</button>
			</div>
		</nav>

		// Hero Section
		<section class="hero">
			<div class="hero-content">
				<h1 class="hero-title">{"Cross-Chain Atomic Swaps"}</h1>
				<p class="hero-subtitle">{"Secure P2P/OTC Exchange without intermediaries"}</p>
				<div class="hero-features">
					<div class="feature-item">
						<span class="feature-icon">{"🔒"}</span>
						<div>
							<h3>{"Non-Custodial"}</h3>
							<p>{"Keep control of your funds"}</p>
						</div>
					</div>
					<div class="feature-item">
						<span class="feature-icon">{"🌐"}</span>
						<div>
							<h3>{"Cross-Chain"}</h3>
							<p>{"Swap between any blockchain"}</p>
						</div>
					</div>
					<div class="feature-item">
						<span class="feature-icon">{"⚡"}</span>
						<div>
							<h3>{"Atomic"}</h3>
							<p>{"Swaps complete or funds returned"}</p>
						</div>
					</div>
				</div>
				<div class="hero-actions">
					<button class="btn btn-primary btn-large" onClick={() => @onAuth()}>{"Start Trading"}</button>
					<button class="btn btn-secondary btn-large" onClick={() => @onAuth()}>{"Sign In"}</button>
				</div>
			</div>
		</section>

		// How It Works
		<section class="how-it-works">
			<h2>{"How Cross-Chain Swaps Work"}</h2>
			<div class="steps">
				<div class="step">
					<div class="step-number">{"1"}</div>
					<h3>{"Create Offer"}</h3>
					<p>{"Specify asset, amount, and counterparty"}</p>
				</div>
				<div class="step">
					<div class="step-number">{"2"}</div>
					<h3>{"Secure Funds"}</h3>
					<p>{"Funds locked in smart contract"}</p>
				</div>
				<div class="step">
					<div class="step-number">{"3"}</div>
					<h3>{"Atomic Swap"}</h3>
					<p>{"Trustless exchange executed"}</p>
				</div>
				<div class="step">
					<div class="step-number">{"4"}</div>
					<h3>{"Complete"}</h3>
					<p>{"Assets delivered to parties"}</p>
				</div>
			</div>
		</section>

		// Supported Chains
		<section class="chains">
			<h2>{"Supported Blockchains"}</h2>
			<div class="chain-grid">
				<div class="chain-item">{"Bitcoin"}</div>
				<div class="chain-item">{"Ethereum"}</div>
				<div class="chain-item">{"Solana"}</div>
				<div class="chain-item">{"Polygon"}</div>
				<div class="chain-item">{"Binance Smart Chain"}</div>
				<div class="chain-item">{"Cardano"}</div>
			</div>
		</section>

		// Footer
		<footer class="footer">
			<p>{"© 2025 CrossSwap. Secure cross-chain atomic swaps."}</p>
		</footer>
	</div>

	<style>
		.landing-container {
			min-height: 100vh;
			font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
			background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
			color: white;
		}

		.navbar {
			display: flex;
			justify-content: space-between;
			align-items: center;
			padding: 1rem 2rem;
			background: rgba(0, 0, 0, 0.1);
		}

		.nav-brand {
			font-size: 1.5rem;
			font-weight: bold;
		}

		.nav-links {
			display: flex;
			gap: 1rem;
		}

		.hero {
			padding: 4rem 2rem;
			text-align: center;
		}

		.hero-title {
			font-size: 3rem;
			margin-bottom: 1rem;
			font-weight: bold;
		}

		.hero-subtitle {
			font-size: 1.2rem;
			margin-bottom: 2rem;
			opacity: 0.9;
		}

		.hero-features {
			display: flex;
			justify-content: center;
			gap: 2rem;
			margin: 3rem 0;
		}

		.feature-item {
			display: flex;
			align-items: center;
			gap: 1rem;
		}

		.feature-icon {
			font-size: 2rem;
		}

		.hero-actions {
			display: flex;
			justify-content: center;
			gap: 1rem;
			margin-top: 2rem;
		}

		.btn {
			padding: 0.5rem 1rem;
			border: none;
			border-radius: 0.5rem;
			cursor: pointer;
			font-size: 1rem;
			transition: all 0.3s ease;
		}

		.btn-primary {
			background: #4f46e5;
			color: white;
		}

		.btn-primary:hover {
			background: #4338ca;
		}

		.btn-secondary {
			background: rgba(255, 255, 255, 0.2);
			color: white;
			border: 1px solid rgba(255, 255, 255, 0.3);
		}

		.btn-secondary:hover {
			background: rgba(255, 255, 255, 0.3);
		}

		.btn-link {
			background: none;
			color: white;
			text-decoration: underline;
		}

		.btn-large {
			padding: 0.75rem 1.5rem;
			font-size: 1.1rem;
		}

		.how-it-works {
			padding: 4rem 2rem;
			background: rgba(255, 255, 255, 0.05);
			text-align: center;
		}

		.how-it-works h2 {
			font-size: 2.5rem;
			margin-bottom: 3rem;
		}

		.steps {
			display: grid;
			grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
			gap: 2rem;
			max-width: 1200px;
			margin: 0 auto;
		}

		.step {
			background: rgba(255, 255, 255, 0.1);
			padding: 2rem;
			border-radius: 0.5rem;
		}

		.step-number {
			width: 3rem;
			height: 3rem;
			background: #4f46e5;
			border-radius: 50%;
			display: flex;
			align-items: center;
			justify-content: center;
			font-weight: bold;
			margin: 0 auto 1rem;
		}

		.chains {
			padding: 4rem 2rem;
			text-align: center;
		}

		.chains h2 {
			font-size: 2.5rem;
			margin-bottom: 2rem;
		}

		.chain-grid {
			display: grid;
			grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
			gap: 1rem;
			max-width: 800px;
			margin: 0 auto;
		}

		.chain-item {
			background: rgba(255, 255, 255, 0.1);
			padding: 1rem;
			border-radius: 0.5rem;
			font-weight: bold;
		}

		.footer {
			padding: 2rem;
			text-align: center;
			background: rgba(0, 0, 0, 0.2);
		}
	</style>
}